import Vue from "vue"
import {SYSTEM_PERMS} from "../config/permissions"
import {USE_DEV_PERMS, USER_DATA} from "../config/config"
import storeHelper from '../utils/storeHelper'
import {notReactiveState} from "./state"
import {DEVICE_NAME, getDeviceId} from "../utils/random";

export default {
  needReLogin: (state, val) => {
    state._needReLogin = Object.assign({}, {value: val, createdAt: +new Date()})
  },
  cleanCache: (state) => {
    state.cache = {}
  },
  breadcrumbs: (state, payload) => {
    let {name, links} = payload;
    state.breadcrumbs[name] = links
  },
  mapLegend: (state, payload) => {
    state.showMapLegend = payload
  },
  setYears:(state, payload) =>{
    state.years=payload
  },
  mappingLayer: (state, payload) => {
    state.showMappingLayer = payload
  },
  setEndpointData: (state, payload) => {
    let {endpoint, data} = payload;
    state.endpoints[endpoint] = Object.assign({}, data)
  },
  skipAsyncData: function (state, options) {
    let {name, value, depth} = options;
    let skipAsyncData = Object.assign({}, state.skipAsyncData);
    skipAsyncData[name] = value;

    if (typeof depth !== 'undefined') {
      let tmp = [];
      name.split('.').forEach((v, i) => {
        if (i < depth) {
          tmp.push(v)
        }
      });
      let searchName = tmp.join(',');
      for (let nameKey in skipAsyncData) {
        if (nameKey.indexOf(searchName) > -1) {
          skipAsyncData[nameKey] = value
        }
      }
    }
    // console.log('skipAsyncData for' + name + ' vlaue' + value)
    state.skipAsyncData = Object.assign({}, skipAsyncData)
  },
  deleteEndpoints: function (state, options) {
    let {endpoints, eager} = options;
    for (let i = 0; i < endpoints.length; i++) {
      let len = eager;
      if (!eager) {
        len = endpoints[i].length
      }
      let name = endpoints[i].substring(0, len);
      for (let key in state.endpoints) {
        if (key.search(name) > -1) {
          delete state.endpoints[key]
        }
      }
      for (let key in notReactiveState.endpoints) {
        if (key.search(name) > -1) {
          delete notReactiveState.endpoints[key]
        }
      }
    }
  },
  tableState: function (state, options) {
    let {id, param, data} = options;
    let stateTables = state.tables;
    if (!stateTables[param]) {
      stateTables[param] = {}
    }
    stateTables[param][id] = data;
    state.tables = Object.assign({}, stateTables)
  },
  mutateError: (state, error) => {
    if (error === null) {
      state._error = null
    } else {
      let formatError = {title: 'Ошибка', message: '', apiUrl: '', status: 0};
      if (error && error.response) {
        // http headers
        if (error.response.status) {
          formatError.status = +error.response.status;
          formatError.title = error.response.status
        }
        if (error.response.statusText) {
          formatError.title = formatError.title + ' ' + error.response.statusText
        }
        if (error.response.message) {
          formatError.message = error.response.message
        } else {
          formatError.message = error.message
        }
        // yii2 message
        if (error.response.data) {
          if (error.response.data.message) {
            formatError.message = error.response.data.message
          }
        }
        // req params
        if (error.response.request && error.response.request.responseURL) {
          formatError.apiUrl = error.response.request.responseURL
        }
      } else if (error && error.message) {
        formatError.message = error.message
      }

      if (formatError.message === 'Network Error') {
        formatError.message = 'Нет подключения к интернету либо не настроен CORS'
      }
      state._error = Object.assign({}, formatError)
    }
  },
  toggleMenu (state) {
    state.menustate = !state.menustate
  },
  closeMenu (state) {
    state.menustate = false
  },
  mutateModelDelete (state, payload) {
    let {data, endpoint, offline} = payload;
    let endpointsData = state.endpoints;
    if (!endpointsData[endpoint]) {
      return
    }
    if (!endpointsData[endpoint]['data']) {
      return
    }
    let i = 0;

    for (; i < endpointsData[endpoint]['data'].length; i++) {
      if (offline && endpointsData[endpoint]['data'][i]._storeUUID && endpointsData[endpoint]['data'][i]._storeUUID === data._storeUUID) {
        break
      } else if (data && data.id && endpointsData[endpoint]['data'][i]['id'] === data.id) {
        break
      }
    }
    console.log('find to delete ' + i);

    endpointsData[endpoint]['data'].splice(i, 1)
  },
  mutateModel (state, payload) {
    let {data, endpoint, offline} = payload;
    let endpointsData = state.endpoints;

    if (!endpointsData[endpoint]) {
      endpointsData[endpoint] = {}
    }
    if (!endpointsData[endpoint].data) {
      endpointsData[endpoint].data = []
    }
    for (let i = 0; i < endpointsData[endpoint].data.length; i++) {
      if (offline && endpointsData[endpoint].data[i]._storeUUID && endpointsData[endpoint].data[i]._storeUUID === data._storeUUID) {
        endpointsData[endpoint].data[i] = data
      } else if (data && data.id && endpointsData[endpoint].data['id'] === data.id) {
        endpointsData[endpoint].data[i] = data
      }
    }
  },
  mutateCache: function (state, payload) {
    let {endpoint, cache = 0} = payload;
    state.cache[endpoint] = +Date.now() + cache
  },
  mutateEndpoint: function (state, payload) {
    let {response, endpoint, action = 'replace', id, notReactive = false} = payload;
    let newData = response.data;

    let endpointsData;
    if (notReactive) {
      endpointsData = notReactiveState.endpoints
    } else {
      endpointsData = Object.assign({}, state.endpoints)
    }

    if (!endpointsData[endpoint]) {
      endpointsData[endpoint] = {}
    }
    if (!endpointsData[endpoint].data) {
      if (typeof endpointsData[endpoint] !== 'object') {
        console.warn('Force type conversion at', endpoint);
        endpointsData[endpoint] = {
          data: []
        }
      } else {
        endpointsData[endpoint].data = []
      }
    }

    if (action === 'prepend') {
      endpointsData[endpoint].data.unshift(newData)
    } else if (action === 'replace') {
      endpointsData[endpoint] = newData
    } else if (action === 'insertAfter') {
      let index = endpointsData[endpoint].data.findIndex(v => v.id === id);
      endpointsData[endpoint].data.splice(index + 1, 0, ...newData.data)
    }

    if (notReactive) {
      notReactiveState.endpoints = endpointsData
    } else {
      state.endpoints = Object.assign({}, endpointsData)
    }
  },
  userDelAuthData: function (state) {
    state._userData = null;
    window.localStorage.removeItem(USER_DATA);
    state.endpoints = {}
  },
  userSetAuthData: function (state, userData) {
    /* if (typeof userData !== 'object') {
      console.warn('Force type conversion userData to object at userSetAuthData mutation')
      console.warn('Used legacy auth')
      userData = {
        access_token: 'Fake legacy token',
        perms: [...PERMS_ALL]
      }
    } */
    console.warn('userSetAuthData', 'devId', getDeviceId());
    if (userData && userData.access_token) {
      if (userData.permissions && Array.isArray(userData.permissions)) {
        userData.perms = [...SYSTEM_PERMS, ...userData.permissions]
      }
    }
    if (!userData.perms) {
      userData.perms = SYSTEM_PERMS
    }
    // TODO: for debug only
    if (USE_DEV_PERMS) {
      console.warn('Used development permissions...');
      userData.perms = JSON.parse(window.localStorage.getItem('perms')) || []
    }
    state._userData = Object.assign({}, userData);
    window.localStorage.setItem(USER_DATA, JSON.stringify(userData));
    if (Vue.prototype.$bugsnagClient) {
      Vue.prototype.$bugsnagClient.user = {
        id: state._userData.id || -1,
        [DEVICE_NAME]: getDeviceId(),
        email: storeHelper.depersonalize(state._userData.email),
        username: storeHelper.depersonalize(state._userData.username),
        perms: state._userData.perms
      }
    }
  },
  userSetRedirectUrl: (state, url) => {
    let blackList = ['main.error', 'auth.login', 'geo.objects', 'publicFiles.files'];
    if (url && url.name && blackList.indexOf(url.name) > -1) {
      return
    }
    state._redirectUrl = url
  },
  mutateFormState: (state, data = {disabledForms: {}}) => {
    state.forms = Object.assign(state.forms, data)
  },
  charts: (state, data) => {
    state.charts = state.charts ? Object.assign(state.charts, data) : data
  },
  preloader: (state, data) => {
    state.preloader = data
  },
  preloaderOn: (state, data) => {
    state.preloaderOn = data
  },
  preloaderStart: (state) => {
    state.preloaderLoad++;
  },
  preloaderEnd: (state) => {
    state.preloaderLoad--;
  },
}
